import React from 'react';
export var ArrowLeft = function ArrowLeft(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    transform: "translate(-847.775 -190.075) rotate(180)"
  }, React.createElement("path", {
    d: "M-861.7-217.6l-14.8-15.8l4.4-4.7l22.6,24l-22.4,24l-4.4-4.7l14.8-15.8H-894v-6.8L-861.7-217.6z"
  })));
};